// Internal accounts are an unlimited tier, so ?preview=free is the only way to
// see the limited-plan rewards UI without a free account.
export const isFreePreview = () =>
  new URLSearchParams(window.location.search).get("preview") === "free";

export const PREVIEW_QUOTA = {
  tier: "FREE",
  limit: 10,
  baseLimit: 5,
  referralCredits: 10,
  trophyGain: 3,
  used: 7,
  resetsAt: new Date(Date.now() + 12 * 24 * 60 * 60 * 1000).toISOString(),
  freeDays: 3,
  freeDayLimit: 10,
  streakDays: 3,
  canClaimToday: true,
  boosts: [
    {
      type: "DISCORD_BOT",
      clips: 5,
      completed: true,
      steps: [
        { step: "IN_SERVER_WITH_BOT", completed: true },
        { step: "ALERTS_CHANNEL", completed: true },
      ],
    },
    {
      type: "STEAM_BOT",
      clips: 3,
      completed: false,
      steps: [{ step: "STEAM_BOT_FRIEND", completed: false }],
    },
  ],
};

const tiers = (thresholds: number[]) =>
  Object.fromEntries(
    ["bronze", "silver", "gold", "platinum", "diamond"].map((tier, index) => [
      tier,
      thresholds[index],
    ]),
  );

// Same shape as GET_TROPHY_PROGRESS, one trophy in each state.
export const PREVIEW_TROPHY_PROGRESS = {
  profile: {
    trophyProgress: [
      { key: "CRT_CLIPS", tier: "BRONZE", value: 40 },
      { key: "STRK_DAILY_CLAIM", tier: "SILVER", value: 22 },
      { key: "CRT_COMMAND", tier: null, value: 3 },
    ],
  },
  trophyDefinitions: [
    {
      key: "CRT_CLIPS",
      name: "Clipper",
      description: "Create X clips",
      thresholds: tiers([10, 50, 250, 1000, 2500]),
    },
    {
      key: "STRK_DAILY_CLAIM",
      name: "Collector",
      description: "Claim your free daily clip X times",
      thresholds: tiers([5, 15, 30, 60, 120]),
    },
    {
      key: "COMP_PARTICIPATE",
      name: "Competitor",
      description: "Participate in an Allstar competition",
      thresholds: tiers([1, 3, 10, 25, 75]),
    },
    {
      key: "CRT_COMMAND",
      name: "Allstar Clip That",
      description: "Clip X plays with !allstar",
      thresholds: tiers([5, 25, 100, 250, 500]),
    },
  ],
};
